import React from 'react'
import { Link, Image } from 'newComponents'
import arrow from '../../../images/icons/arrow-right-turquoise.svg'
import './styles.scss'

const LinkWithArrow = ({ to, children, className, left }) => {
  if (!children || !to) return null
  const leftAlign = left ? 'left' : ''
  const wrapText = children.length > 20 ? 'wrap-text' : ''

  return (
    <div className={`link-arrow-container ${className || ''} ${leftAlign} ${wrapText}`}>
      <Link className="link-arrow-link" to={to}>
        {children}
        <Image className="link-arrow-image" image={arrow} />
      </Link>
    </div>
  )
}
export default LinkWithArrow
